import { render, staticRenderFns } from "./UserInfoModal.vue?vue&type=template&id=06662ff4"
import script from "./UserInfoModal.vue?vue&type=script&lang=ts"
export * from "./UserInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports